/* gl_checkbox.module.js */

var angular = require("angular");

module.exports = angular.module("gl_checkbox", []);


/* Generated Dependencies */
module.exports.directive("glCheckbox", require('././directives/gl_checkbox.directive.js'));